<script setup lang="ts">
import { onMounted, ref, watch } from 'vue'
import { Loader2 } from 'lucide-vue-next'
import noImg from "../../../assets/images/no-image.png";
import { setDefaultImage } from '../../../utils/CommonFunctions';
import IconComponent from '../common/IconComponent.vue';
import { api } from '../../../api/Api';

const props = withDefaults(defineProps<{
  src: string | null | undefined
  alt?: string
  className?: string
  readonly?: boolean
  allowPreview?: boolean
}>(), {
  alt: '',
  className: '',
  readonly: false,
  allowPreview: true
})

const emit = defineEmits<{
  (e: 'remove'): void
}>()

const imageData = ref()
const loading = ref(true)

onMounted(async () => {
  if (!props.src) {
    loading.value = false
    imageData.value = noImg
    return;
  }
  console.log('Fetching image data for', props.src);
  const response = await api.post("image/data",
      {
        filename: props.src
      }, {
        hideError: true,
        skipLoading: true
      }
    );
    /*if (resp.success == true) {
      console.log(resp.data);
    }

  let response = await getBase64Image(props.src || '');*/
  loading.value = false
  imageData.value = response.success &&  response.data ? response.data : noImg
})

watch(() => props.src, async () => {
  if (!props.src) {
    loading.value = false
    imageData.value = noImg
    return
  }
  const response = await api.post("image/data",
      {
        filename: props.src
      }, {
        hideError: true
      }
    );
    /*if (resp.success == true) {
      console.log(resp.data);
    }

  let response = await getBase64Image(props.src || '');*/
  loading.value = false
  imageData.value = response.success &&  response.data ? response.data : noImg
})

const handleRemove = () => {
    imageData.value = ''
    emit('remove')
}

const showPreview = ref(false)

</script>

<template>
  <div v-if="loading" class="flex items-center justify-center">
    <Loader2 class="w-6 h-6 animate-spin" />
  </div>
  <div 
    v-if="showPreview && allowPreview" 
    class="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50"
    @click="showPreview = false"
  >
    <img :src="imageData" class="max-w-full max-h-full" />
  </div>
  <img 
    v-else 
    :src="imageData" 
    :alt="alt" 
    :class="className" 
    @error="setDefaultImage" 
    @click="showPreview = true" 
    class="cursor-pointer object-contain "
  />

  
  <button 
        v-if="imageData && !readonly"
        @click="handleRemove"
        class="top-0 right-0 p-1 bg-red-500 rounded-full text-white opacity-0 group-hover:opacity-100 transition-opacity duration-200 hover:bg-red-600"
    >
        <IconComponent name="Trash" class="w-4 h-4" />
    </button>
</template>